import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { recordActions } from '../../config/configuration/react';

export const useOffers = ({ recordId, type }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const offers = useSelector((state) => state.reduxRecords.data[recordId]?.trade?.offers || []);
  const sales = useSelector((state) => state.reduxRecords.data[recordId]?.trade?.sale || {});
  const status = useSelector((state) => state.reduxRecords.data[recordId]?.trade?.sale?.sale_status?.name);
  const tradeId = useSelector((state) => state.reduxRecords.data[recordId]?.record?.autobizTradeUuid);
  const isMounted = useRef(false);
  const supOfferId = offers?.length > 0 ? _.maxBy([...offers], (o) => o.amount).id || null : null;

  const setloadingStatus = (res) => {
    if (isMounted.current) return;
    setLoading(res);
  };

  const setErrorStatus = (res) => {
    if (isMounted.current) return;
    setError(res);
  };

  useEffect(() => {
    if (status !== undefined && !['scheduled', 'draft'].includes(status) && tradeId !== null) {
      dispatch(recordActions.getOffersApi({ type, setloadingStatus, setErrorStatus }));
    }
    return () => {
      isMounted.current = true;
    };
  }, []);

  return { offersLoading: loading, setLoading, offersErrorApi: error, offers, sales, supOfferId };
};
